import KeyMirror from "keymirror";

export const ActionTypes = KeyMirror({
  ADD_HEATMAPS: null
});

export interface IHeatmapsState {
  heatmaps: Heatmap[],
}
